/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.buttonCustom = this.querySelector('.load-more-custom');
      this.total_page = this.button.dataset.totalPage;
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.customSorted = this.grid.dataset.customSorted;
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = this.grid.dataset.currentPage ? parseInt(this.grid.dataset.currentPage) : 2;
      this.current_page = this.grid.dataset.currentPage ? parseInt(this.grid.dataset.currentPage) : 1;
      this.skippedPage = false;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.grid.dataset.currentPage,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }
      this.current_page = newParam;
      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function() {
        base.loadProducts();
        this.blur();

        let isPromotionBanner = document.querySelector('.promotion-column');
        if(isPromotionBanner) {
          const productGrid = document.getElementById('product-grid');
          productGrid.classList.add('is-promotion-banner');
        }

        return false;
      });
      this.buttonCustom.addEventListener('click', function(){
        let productGrid = document.getElementById('product-grid');
        let shoesGrid = [];
        let accesoriesGrid = [];
        let othersGrid = [];
        if(productGrid) {
          let hiddenProducts = productGrid.querySelectorAll('.column.is-hidden');
          for(let i = 0; i < hiddenProducts.length; i++) {
            let cardElement = hiddenProducts[i];
            if(cardElement.classList.value.indexOf('shoes') != -1) {
              shoesGrid.push(cardElement);
              cardElement.remove();
            } else if(cardElement.classList.value.indexOf('accessories') != -1) {
              accesoriesGrid.push(cardElement);
              cardElement.remove();
            } else {
              othersGrid.push(cardElement);
              cardElement.remove();
            }
          }
          const elemArray = Array.prototype.concat(shoesGrid, accesoriesGrid, othersGrid);
          elemArray.forEach(function(elem, index) {
            elem.classList.remove('is-hidden');
            productGrid.appendChild(elem);
          });
        }

        base.buttonCustom.classList.add('is-hidden');
        productGrid.classList.add('pagination--last-page');

        return false;
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function(entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
      url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      if (base.getAttribute('loading')) {
        return;
      }
      base.i = parseInt(this.grid.dataset.currentPage);
      base.i++;
      base.grid.dataset.currentPage = base.i;
      url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);
          if (base.i <=  this.total_page) {
            dispatchCustomEvent('pagination:page-changed', {
              url: url
            });
          } else {
            // Remove the "Load More" button when all products have been displayed
            if (base.button) {
              base.button.classList.add('is-hidden')
            }
            let hiddenProducts = base.grid.querySelectorAll('.column.is-hidden');
            if (base.buttonCustom && hiddenProducts.length > 0) {
              base.buttonCustom.classList.remove('is-hidden')
            }
             else {
              if (base.button) {
                this.classList.add('is-hidden')
              }
            }
          }
          if(base.customSorted && base.i == this.total_page) {
            let hiddenProducts = base.grid.querySelectorAll('.column.is-hidden');
            if (base.buttonCustom && hiddenProducts.length > 0) {
              base.buttonCustom.classList.remove('is-hidden');
              base.button.classList.add('is-hidden')
            }
          }
        });
    }
    renderProducts(html, url) {
     let base = this,
      currentTemporaryProductCards = base.grid.querySelectorAll('.from-next-page'),
      grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
      base.skippedPage = false;

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }
      let products = grid_to_replace.querySelectorAll('.column');
      let hiddenFetchProducts = grid_to_replace.querySelectorAll('.column.is-hidden');
      let unHiddenFetchProducts = grid_to_replace.querySelectorAll('.column:not(.is-hidden)');

      for (var i = 0; i < products.length; i++) {
        let currentGridProductId = base.grid.querySelector(`[pid="${products[i].getAttribute('pid')}"]`);
        if(!currentGridProductId) {
          this.grid.appendChild(products[i]);
        }
      }
      if(unHiddenFetchProducts.length == 0) {
       base.skippedPage = true;
      }
      if(base.customSorted) {
        let unEqualGrid = base.grid.querySelectorAll('.column:not(.is-hidden)').length;
        if((hiddenFetchProducts.length > 0  || unEqualGrid%4 !== 0) && base.i != base.total_page) {
          let nextUrl = document.location.pathname + base.addUrlParam(document.location.search, 'page');
          if(base.i <= base.total_page) {
            fetch(nextUrl)
            .then(response => response.text())
            .then((responseText) => {
              let nextPageProductGrid = new DOMParser().parseFromString(responseText, 'text/html').getElementById('product-grid');
              if(nextPageProductGrid) {
                let productCards = [];
                let nextProducts = nextPageProductGrid.querySelectorAll('.column:not(.is-hidden)');
                if(currentTemporaryProductCards.length < nextProducts.length) {
                  currentTemporaryProductCards.forEach(function(elem) {
                    elem.remove();
                  });
                  for (var i = 0; i < nextProducts.length; i++) {
                    if(nextProducts[i]) {
                      let updatedGridNo = base.grid.querySelectorAll('.column:not(.is-hidden)').length;
                      if(updatedGridNo%4 == 0 && !base.getAttribute('getmore')) {
                        base.removeAttribute('loading');
                        break;
                      }
                      if(nextProducts[i]) {
                        if(base.getAttribute('getmore')) {
                          nextProducts[i].classList.add('from-next-page');
                        }
                        if(base.skippedPage) {
                          nextProducts[i].classList.remove('from-next-page');
                        }
                        productCards.push(nextProducts[i]);
                        this.grid.appendChild(nextProducts[i]);
                      }
                    }
                  }
                  if(base.getAttribute('getmore')) {
                    base.removeAttribute('loading');
                    base.removeAttribute('getmore');
                  } else {
                    //base.setAttribute('loading', true);
                  }

                  return productCards;
                } else {
                  base.removeAttribute('loading');
                  base.setAttribute('getmore', true);
                  base.loadProducts();
                }
              }
            })
          }
        }
      }
      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function() {
            base.removeAttribute('loading');
          }
        });
      } else {
        base.removeAttribute('loading');
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}